export { BackgroundGeolocation } from '@laurentgoudet/ionic-native-background-geolocation/ngx';
export * from './geolocation.service';
